<template>
  <v-select
    :label="label"
    :value="value"
    @change="(value) => $emit('change', value)"
    :items="items"
    :outlined="outlined"
    color="primary-base"
    :disabled="disabled"
    :item-text="itemText"
    :item-value="itemValue"
    :item-disabled="itemDisabled"
    :rules="rules"
    :append-icon="appendIcon"
    :persistent-hint="persistentHint"
    :return-object="returnObject"
    :hint="hint"
    :filled="filled"
    :multiple="multiple"
    :chips="chips"
    :deletable-chips="deletableChips"
    class="dropdown"
    :class="{ 'is-title': title }"
    :hide-details="hideDetails"
    :dense="dense"
    :single-line="singleLine"
    :rounded="rounded"
    :height="height"
    :placeholder="placeholder"
    :errorMessages="errorMessages"
  >
    <template v-slot:selection="{ item }">
      <slot
        v-if="hasSelectionSlot"
        name="selection"
        class="d-flex justify-end"
        :item="item" />
      <span
        v-else
        :class="{ 'dropdown-text-title': title, [selectionClass]: true, 'grey--text': item.disabled }"
        class="nick-subtitle-2 uppercase">
        {{ typeof itemText === 'string' ? getValue(item, itemText) : item.text }}
      </span>
    </template>
    <template v-slot:item="{ item }">
      <slot
        v-if="hasItemSlot"
        name="item"
        :item="item" />
      <span
        v-else
        :class="{ 'dropdown-text-title': title, 'grey--text': item.disabled }"
        class="nick-subtitle-2 uppercase">
        {{ typeof itemText === 'string' ? getValue(item, itemText) : item.text }}
      </span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: {
    type: String,
    label: String,
    value: null,
    items: Array,
    disabled: Boolean,
    readonly: Boolean,
    itemText: [String, Function],
    placeholder: String,
    itemValue: String,
    itemDisabled: String,
    filled: Boolean,
    color: String,
    rules: Array,
    returnObject: Boolean,
    appendIcon: String,
    persistentHint: Boolean,
    hint: String,
    hasSelectionSlot: Boolean,
    hasItemSlot: Boolean,
    multiple: Boolean,
    chips: Boolean,
    deletableChips: Boolean,
    title: Boolean,
    hideDetails: Boolean,
    dense: Boolean,
    singleLine: Boolean,
    rounded: Boolean,
    outlined: Boolean,
    height: [Number, String],
    selectionClass: String,
    errorMessages: Array,
    minContent: Boolean
  },
  data () {
    return {
      display: null
    }
  },
  methods: {
    getValue (obj, path) {
      return path.split('.').reduce((o, i) => o[i], obj)
    }
  },
  watch: {
    items: {
      handler: function (list) {
        if (list && list.length === 1 && !list[0].disabled) {
          this.$emit('change', this.returnObject
            ? list[0]
            : this.itemValue
              ? this.getValue(list[0], this.itemValue)
              : list[0].value)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>

::v-deep {
  fieldset {
    color: var(--v-accent-base) !important;
  }
  .v-input__icon--append .v-icon {
    color: var(--v-primary-base) !important;
    margin: auto !important;
  }
  .v-input__append-inner {
    margin: auto !important;
  }
  span {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  .v-input__slot {
    @media (max-width: 960px) {
      padding: 0 18px !important;
    }
    @media (min-width: 961px) {
      padding: 0 18px 0 24px !important;
    }
  }
}
.dropdown {
  border-radius: 10px;
}
.dropdown-text-title {
  font-size: 32px;
  line-height: normal;
}
</style>
